module.exports = __webpack_public_path__ + "img/kube-logo.cbbc892.svg";